import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import ReactOnRails from 'react-on-rails';

import FinishSetUpApp from './FinishSetUpAppClient';
import NewAccountApp from './NewAccountAppClient.jsx';

import DemoAccountBanner from '../../Teacher/components/shared/demoAccountBanner';
import PreNavigationBanner from '../../Shared/components/shared/preNavigationBannerApp';
import StudentsOnlineNavbarButton from '../../Teacher/startup/StudentsOnlineNavbarButtonLazyClient';

ReactOnRails.register({ NewAccountApp, FinishSetUpApp, DemoAccountBanner, PreNavigationBanner, });

// Rendered by the shared teacher sub-header, so every ReactOnRails bundle must know it
ReactOnRails.register({ StudentsOnlineNavbarButton });
